<template>
  <div>
    <div v-if="from === 'privacy'">
      <div class="c-logo">
        <img src="@/assets/img/ztk_logo.svg" alt="ZTK Logo" />
      </div>
      <p>
        <b
          >Bitte lesen und bestätigen Sie, dass Sie mit den
          Datenschutzbestimmungen einverstanden sind.</b
        >
      </p>
    </div>
    <ion-list lines="none">
      <!-- <ion-item>
      <ion-checkbox slot="start" v-model="privacy1"> </ion-checkbox>
      <ion-label class="ion-text-wrap" color="primary">
        Ich möchte von den Zahnärztlichen Tageskliniken kontaktiert werden und
        stimme der
        <u
          ><a href="#" @click.prevent="openInfoModal(privacy1Text)"
            >Verarbeitung meiner personenbezogenen Daten
          </a></u
        >
        durch die Zahnärztlichen Tageskliniken zu.
      </ion-label>
    </ion-item> -->
      <ion-item>
        <ion-checkbox slot="start" v-model="privacy2"> </ion-checkbox>
        <ion-label class="ion-text-wrap" color="primary">
          Ich suche einen Zahnarzt und möchte einen Arzttermin bei den
          zahnärztlichen Tageskliniken buchen und stimme den
          <u
            ><a href="#" @click.prevent="openInfoModal(privacy2Text)"
              >Datenschutzbestimmungen</a
            ></u
          >
          zu.
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-row v-if="from === 'privacy'">
      <ion-col>
        <next-question-button
          :disabled="!privacy1 || !privacy2"
          @click="$emit('done')"
        />
      </ion-col>
    </ion-row>
  </div>
</template>

<script>
import {
  IonList,
  IonItem,
  IonCheckbox,
  IonLabel,
  modalController,
  IonRow,
  IonCol,
} from "@ionic/vue";
import NextQuestionButton from "@lib/components/Questions/NextQuestionButton";
import InfoModal from "@lib/components/InfoModal";

export default {
  emits: ["done", "checked", "unchecked"],
  components: {
    IonList,
    IonItem,
    IonCheckbox,
    IonLabel,
    NextQuestionButton,
    IonRow,
    IonCol,
  },
  props: {
    from: {
      required: false,
      default: "",
    },
  },
  data() {
    return {
      privacy1: false,
      privacy2: false,
      privacy1Text:
        "<p>Ihre angegebenen Daten (Anrede, Vorname, Nachname, PLZ, E-Mail-Adresse, Telefonnummer) werden im Zuge der Vertragserfüllung an die Zahnärztlichen Tageskliniken weitergegeben und verarbeitet. Die Rechtsgrundlage iSd Datenschutz-Grundverordnung (DSGVO) ist hierbei Art 6 Abs 1 lit b DSGVO.</p><p>Die bei den Zahnärztlichen Tageskliniken in diesem Zusammenhang gespeicherten Daten werden ausschließlich zu Zwecken des telefonischen Rückrufs oder zur Kontaktaufnahme per E-Mail verarbeitet. Sie können jederzeit die Kontaktaufnahme untersagen oder die Löschung Ihrer Daten verlangen. (Widerrufsmöglichkeit der Einwilligung gemäß Art 7 Abs.3 DSGVO)</p>",
      privacy2Text:
        "<p>Die Angaben zu meinen Ihren Symptomen, Vorname, Nachname, Alter und Geschlecht, Telefonnummer, Information zur ARAG-Krankenversicherung und die Vertragsdaten (E-Mail-Adresse, Passwort, Vorname, Nachname und Adresse) werden an die Zahnärztlichen Tageskliniken weitergegeben und von diesen gespeichert und verarbeitet, um die individuelle Suche, nach einem Arzttermin bearbeiten zu können. Damit Ihre Suchanfrage beantwortet werden kann, benötigen die Zahnärztlichen Tageskliniken von Ihnen ebenso Angaben zu Ihrer physischen und möglicherweise auch psychischen Verfassung. Hierbei handelt es sich um Gesundheitsdaten im Sinne der Datenschutz-Grundverordnung Art.4 Nr.15 DSGVO.</p><p>Ferner werden die Daten des behandelnden Arztes (Vorname, Nachname, Fachrichtung), Zeitpunkt und Ort des Termins verarbeitet und an Roodie weitergegeben. Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder geistige Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.</p>",
    };
  },
  watch: {
    privacy1() {
      this.checkPrivacy();
    },
    privacy2() {
      this.checkPrivacy();
    },
  },
  methods: {
    checkPrivacy() {
      if (
        // this.privacy1 &&
        this.privacy2
      ) {
        this.$emit("checked");
      } else {
        this.$emit("unchecked");
      }
    },
    async openInfoModal(text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          title: "Datenschutzbestimmungen",
          text: text,
        },
      });
      return modal.present();
    },
  },
};
</script>

<style lang="scss" scoped>
.c-logo {
  max-width: 200px;
  display: inline-block;
  margin-right: 20px;
}
</style>
